"use client";

import { useLayoutEffect } from "react";

/**
 * Anchor a form→result swap to the top of the viewport BEFORE paint (rule 58).
 *
 * `useLayoutEffect`, never `useEffect`, and `behavior: "auto"`, never `"smooth"`:
 * the growth from a short form to a tall result lands hundreds of milliseconds
 * after the submit tap, so it is outside CLS's input-exclusion window and counts
 * in full. A post-paint effect runs after the shift has already painted — that
 * is exactly why the pre-2026-06-22 scroll fix never helped.
 *
 * Extracted so every matching mode shares ONE anchor rather than each result
 * surface growing its own near-copy (rules 23/24).
 */
export function useResultScrollAnchor(hasResult: boolean): void {
  useLayoutEffect(() => {
    if (typeof window === "undefined" || !hasResult) return;
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [hasResult]);
}
